module.exports = __webpack_public_path__ + "assets/images/covid-hits-home-2.jpg?v=7c5462c8";